import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  seriesGenre: string;
  seriesGenreId: null | number;
};

const initialState: InitialState = {
  seriesGenre: "all",
  seriesGenreId: null,
};

const seriesGenreSlice = createSlice({
  name: "seriesGenreSlice",
  initialState,
  reducers: {
    setSeriesGenre: (
      state,
      action: PayloadAction<{ series: string; id: number | null }>
    ) => {
      state.seriesGenre = action.payload.series;
      state.seriesGenreId = action.payload.id;
      return state;
    },
    resetSeriesGenre: (state, action: PayloadAction) => {
      state.seriesGenre = "all";
      state.seriesGenreId = null;
      return state;
    },
  },
});

export const { setSeriesGenre, resetSeriesGenre } = seriesGenreSlice.actions;
export default seriesGenreSlice;
